import { useAuthStore } from '../stores/auth.store'

/** Anything with a droppable query cache (structural subset of TanStack QueryClient). */
interface QueryCacheResetter {
  removeQueries(): void
}

/**
 * Cached queries were fetched with the previous city's X-City-Id header and
 * query keys are city-agnostic, so a city switch must drop the cache —
 * otherwise screens keep serving the previous city's data until refetch.
 */
export function watchCityScope(queryClient: QueryCacheResetter): () => void {
  let lastCityId = useAuthStore.getState().activeCityId

  return useAuthStore.subscribe((state) => {
    if (state.activeCityId !== lastCityId) {
      lastCityId = state.activeCityId
      queryClient.removeQueries()
    }
  })
}
